module.exports = __webpack_public_path__ + "static/media/GMMI_Logo_160.5e2be226.png";